<template>
  <action-person-template :action="action" column="person2" grid="person2" title="Gardien"/>
</template>

<script>
import ActionPersonTemplate from './ActionPersonTemplate'

export default {
  name: 'SportFootballMatchActionPersonGoalkeeper',
  props: {
    action: Object
  },
  components: { ActionPersonTemplate }
}
</script>
